import { useDictStore } from "@/stores/dictStore";
import { InstallationItem } from "../../entities/installation";
import { Partition } from "../../entities/partition";
import { CreateOneStrategy } from "../base/creation.strategy";
import { Pricing } from "../../entities/pricing";
import { isKompasSystem } from "@/app/predicates/systems.predicates";

export class InstallationDividerCreationStrategy extends CreateOneStrategy {
    constructor(
        partition: Partition,
        isSteel: boolean,
        systemCode: string,
        deliveryTime: number,
        spaceTitle?: string
    ) {
        const dicts = useDictStore();
        const code = isKompasSystem(systemCode) ? 'kmp' : systemCode;
        const installationInfo = dicts.findDeliveryDividerPriceMin(
            code,
            deliveryTime,
        );
        const partitionArea = parseFloat(partition.dimensions.getAreaFt().toSquareFt().formatSq()) * parseFloat(partition.qty)
        const installationPricePerSqFt = installationInfo?.price_multiplier || 0;
        const installationItemSum = +partitionArea * installationPricePerSqFt;

        const installationItemConfig = {
            title: installationInfo?.title ?? "",
            partitionName: `${spaceTitle} ${partition.title}`,
            minPrice: installationInfo?.price_min || 0,
            parentId: partition.id,
            qty: partitionArea,
            price: new Pricing(
                installationPricePerSqFt,
                installationPricePerSqFt,
                installationPricePerSqFt,
            ),
            sum: new Pricing(
                installationItemSum,
                installationItemSum,
                installationItemSum,
            ),
        };

        super(installationItemConfig, InstallationItem);
    }
}
export class InstallationDoorCreationStrategy extends CreateOneStrategy {
    constructor(
        partition: Partition,
        isSteel: boolean,
        systemCode: string,
        deliveryTime: number,
        spaceTitle?: string,
    ) {
        const dicts = useDictStore();

        const getMostExpensiveDoor = () => {
            return partition.getAllDoors().reduce<ReturnType<typeof dicts.findDeliveryDoorPriceMin> | null>((max, door) => {
                const installationInfo = dicts.findDeliveryDoorPriceMin(
                    systemCode,
                    door.structureType,
                    deliveryTime,
                );

                if (
                    !max ||
                    (installationInfo?.price_min ?? 0) > (max?.price_min ?? 0)
                ) {
                    return installationInfo;
                }
                return max;
            }, null)
        }

        const installationInfo = getMostExpensiveDoor();
        const partitionArea = parseFloat(partition.dimensions.getAreaFt().toSquareFt().formatSq()) * parseFloat(partition.qty);

        const installationPricePerSqFt = installationInfo?.price_multiplier || 0;

        const installationItemSum = +partitionArea * installationPricePerSqFt;

        const installationItemConfig = {
            title: installationInfo?.title ?? "",
            partitionName: `${spaceTitle} ${partition.title}`,
            minPrice: installationInfo?.price_min || 0,
            parentId: partition.id,
            qty: partitionArea,
            price: new Pricing(
                installationPricePerSqFt,
                installationPricePerSqFt,
                installationPricePerSqFt,
            ),
            sum: new Pricing(
                installationItemSum,
                installationItemSum,
                installationItemSum,
            ),
        };

        super(installationItemConfig, InstallationItem);
    }
}
